import Vue from 'vue'
import VueRouter from 'vue-router'

// Admin Views
import AdminLogin from '@/views/admin/Login.vue'
import AdminDashboard from '@/views/admin/Dashboard.vue'
import AdminLayout from '@/views/admin/Layout.vue'

// Concursos
import ConcursosLista from '@/views/admin/Concursos/Lista.vue'
import ConcursoFormulario from '@/views/admin/Concursos/Formulario.vue'
import ConcursoDetalhes from '@/views/admin/Concursos/Detalhes.vue'

// Candidatos
import CandidatosLista from '@/views/admin/Candidatos/Lista.vue'
import CandidatoDetalhes from '@/views/admin/Candidatos/Detalhes.vue'
import InscricoesLista from '@/views/admin/Candidatos/Inscricoes/Lista.vue'

// Isenções
import IsencoesLista from '@/views/admin/Isencoes/Lista.vue'
import IsencaoAnalise from '@/views/admin/Isencoes/Analise.vue'

// Recursos
import RecursosLista from '@/views/admin/Recursos/Lista.vue'
import RecursosPrazos from '@/views/admin/Recursos/Prazos.vue'
import RecursoAnalise from '@/views/admin/Recursos/Analise.vue'

// Envios
import EnviosLista from '@/views/admin/Envios/Lista.vue'
import EnviosPrazos from '@/views/admin/Envios/Prazos.vue'
import EnvioValidacao from '@/views/admin/Envios/Validacao.vue'

// Relatórios
import RelatoriosConcursos from '@/views/admin/Relatorios/Concursos.vue'
import RelatoriosCandidatos from '@/views/admin/Relatorios/Candidatos.vue'
import RelatoriosFinanceiro from '@/views/admin/Relatorios/Financeiro.vue'

// Configurações
import ConfiguracoesAdministradores from '@/views/admin/Configuracoes/Administradores.vue'
import ConfiguracoesSistema from '@/views/admin/Configuracoes/Sistema.vue'

// Logs
import LogsLista from '@/views/admin/Logs/Lista.vue'

// Reembolsos
import ReembolsosLista from '@/views/admin/Reembolsos/Lista.vue'

// Boletos
import BoletosLista from '@/views/admin/Boletos/Lista.vue'

// Documentos / Cartões resposta
import DocumentosCartoes from '@/views/admin/DocumentosCartoes.vue'

Vue.use(VueRouter)

const adminRoutes = [
  {
    path: '/admin',
    redirect: '/admin/login'
  },
  {
    path: '/admin/login',
    name: 'admin-login',
    component: AdminLogin,
    meta: { 
      requiresGuest: true,
      title: 'Login Administrativo'
    }
  },

  {
    path: '/admin/dashboard',
    component: AdminLayout,
    meta: { 
      requiresAuth: true,
      title: 'Dashboard Administrativo'
    },
    children: [
      {
        path: '',
        name: 'admin-dashboard',
        component: AdminDashboard,
        meta: { 
          title: 'Dashboard',
          icon: 'fas fa-tachometer-alt'
        }
      },
      // Concursos
      {
        path: 'concursos',
        name: 'admin-concursos',
        component: ConcursosLista,
        meta: { 
          title: 'Gestão de Concursos',
          icon: 'fas fa-clipboard-list'
        }
      },
      {
        path: 'concursos/novo',
        name: 'admin-concurso-novo',
        component: ConcursoFormulario,
        meta: { 
          title: 'Novo Concurso',
          icon: 'fas fa-plus'
        }
      },
      {
        path: 'concursos/editar/:id',
        name: 'admin-concurso-editar',
        component: ConcursoFormulario,
        meta: { 
          title: 'Editar Concurso',
          icon: 'fas fa-edit'
        }
      },
      {
        path: 'concursos/detalhes/:id',
        name: 'admin-concurso-detalhes',
        component: ConcursoDetalhes,
        meta: { 
          title: 'Detalhes do Concurso',
          icon: 'fas fa-eye'
        }
      },
      // Candidatos
      {
        path: 'candidatos',
        name: 'admin-candidatos',
        component: CandidatosLista,
        meta: { 
          title: 'Gestão de Candidatos',
          icon: 'fas fa-users'
        }
      },
      {
        path: 'candidatos/detalhes/:id',
        name: 'admin-candidato-detalhes',
        component: CandidatoDetalhes,
        meta: { 
          title: 'Detalhes do Candidato',
          icon: 'fas fa-user'
        }
      },
      {
        path: 'inscricoes',
        name: 'admin-inscricoes',
        component: InscricoesLista,
        meta: { 
          title: 'Gestão de Inscrições',
          icon: 'fas fa-file-alt'
        }
      },
      // Isenções
      {
        path: 'isencoes',
        name: 'admin-isencoes',
        component: IsencoesLista,
        meta: { 
          title: 'Gestão de Isenções',
          icon: 'fas fa-percentage'
        }
      },
      {
        path: 'isencoes/analise/:id',
        name: 'admin-isencao-analise',
        component: IsencaoAnalise,
        meta: { 
          title: 'Análise de Isenção',
          icon: 'fas fa-search'
        }
      },
      // Recursos
      {
        path: 'recursos',
        name: 'admin-recursos',
        component: RecursosLista,
        meta: { 
          title: 'Gestão de Recursos',
          icon: 'fas fa-gavel'
        }
      },
      {
        path: 'recursos/prazos',
        name: 'admin-recursos-prazos',
        component: RecursosPrazos,
        meta: { 
          title: 'Prazos de Recursos',
          icon: 'fas fa-calendar-alt'
        }
      },
      {
        path: 'recursos/analise/:id',
        name: 'admin-recurso-analise',
        component: RecursoAnalise,
        meta: { 
          title: 'Análise de Recurso',
          icon: 'fas fa-search'
        }
      },
      // Envios
      {
        path: 'envios',
        name: 'admin-envios',
        component: EnviosLista,
        meta: { 
          title: 'Gestão de Envios',
          icon: 'fas fa-paper-plane'
        }
      },
      {
        path: 'documentos/cartoes-resposta',
        name: 'admin-documentos-cartoes',
        component: DocumentosCartoes,
        meta: {
          title: 'Cartões Resposta Corrigidos',
          icon: 'fas fa-file-pdf'
        }
      },
      {
        path: 'envios/prazos',
        name: 'admin-envios-prazos',
        component: EnviosPrazos,
        meta: { 
          title: 'Prazos de Envios',
          icon: 'fas fa-calendar-alt'
        }
      },
      {
        path: 'envios/validacao/:id',
        name: 'admin-envio-validacao',
        component: EnvioValidacao,
        meta: { 
          title: 'Validação de Envio',
          icon: 'fas fa-check-circle'
        }
      },
      // Relatórios
      {
        path: 'relatorios/concursos',
        name: 'admin-relatorios-concursos',
        component: RelatoriosConcursos,
        meta: { 
          title: 'Relatórios de Concursos',
          icon: 'fas fa-chart-bar'
        }
      },
      {
        path: 'relatorios/candidatos',
        name: 'admin-relatorios-candidatos',
        component: RelatoriosCandidatos,
        meta: { 
          title: 'Relatórios de Candidatos',
          icon: 'fas fa-chart-pie'
        }
      },
      {
        path: 'relatorios/financeiro',
        name: 'admin-relatorios-financeiro',
        component: RelatoriosFinanceiro,
        meta: { 
          title: 'Relatórios Financeiros',
          icon: 'fas fa-chart-line'
        }
      },
      // Configurações
      {
        path: 'configuracoes/administradores',
        name: 'admin-config-administradores',
        component: ConfiguracoesAdministradores,
        meta: { 
          title: 'Gestão de Administradores',
          icon: 'fas fa-user-shield'
        }
      },
      {
        path: 'configuracoes/sistema',
        name: 'admin-config-sistema',
        component: ConfiguracoesSistema,
        meta: { 
          title: 'Configurações do Sistema',
          icon: 'fas fa-cogs'
        }
      },
      // Logs
      {
        path: 'logs',
        name: 'admin-logs',
        component: LogsLista,
        meta: { 
          title: 'Logs do Sistema',
          icon: 'fas fa-history'
        }
      },
      // Reembolsos
      {
        path: 'reembolsos',
        name: 'admin-reembolsos',
        component: ReembolsosLista,
        meta: { 
          title: 'Gestão de Reembolsos',
          icon: 'fas fa-money-bill-wave'
        }
      },
      // Boletos
      {
        path: 'boletos',
        name: 'admin-boletos',
        component: BoletosLista,
        meta: { 
          title: 'Gestão de Boletos',
          icon: 'fas fa-barcode'
        }
      }
    ]
  }
]

export default adminRoutes
